import { render, staticRenderFns } from "./ProjectsReview.vue?vue&type=template&id=1adcd686&"
import script from "./ProjectsReview.vue?vue&type=script&lang=js&"
export * from "./ProjectsReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports